// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SecureBlock_wrapper__qu9Ts"};